<template>
  <div class="student-task-list-page">
    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
      <div slot="header" class="row align-items-center">
        <div class="col-lg-6">
          <h6 class="text-uppercase ls-1 mb-1">Formulir Pendaftaran</h6>
        </div>
        <!-- <div class="col-lg-6 text-lg-right">
          <b-button variant="warning" size="sm" @click="downloadExcel()"><i class="fa fa-download" aria-hidden="true"></i> Download Template Blank</b-button>
          <b-button variant="primary" size="sm" @click="downloadDataUser()"><i class="fa fa-download" aria-hidden="true"></i> Download Template </b-button>
          <b-button variant="info" size="sm" @click="showImportFormModal()"><i class="fa fa-upload" aria-hidden="true"></i> Upload Data</b-button>
          <b-button variant="primary" size="sm" @click="showFormModal(null)"><i class="fa fa-user-plus" aria-hidden="true"></i> Daftar User</b-button>
        </div> -->
      </div>
      <div class="text-center text-muted">
        <div class="card shadow">
          <div class="p-2">
            <b-row>
              <b-col lg="2" class="my-1">
                <!-- <p>
                  Total Siswa Aktif: <b>{{ totalActive }}</b>
                </p> -->
              </b-col>
              <b-col lg="6" class="my-1"> </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.class_id" name="class_id" value-field="id" placeholder="Kelas" text-field="name" data-vv-as="Kelas" :options="classesList"> </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.ta_id" name="ta_id" value-field="id" placeholder="Tahun Ajaran" text-field="name" data-vv-as="Tahun Ajaran" :options="taList"> </b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" @click="getFormulirPendaftaranList()">Filter</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <!-- <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.type" name="type" value-field="id" placeholder="Type" text-field="name" data-vv-as="Type" :options="userTypeList"> </b-form-select>
                </b-input-group>
              </b-col> -->
              <!-- <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.status" name="status" value-field="id" placeholder="Status" text-field="name" data-vv-as="Status" :options="statusList"> </b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" @click="getFormulirPendaftaranList()">Filter</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col> -->
            </b-row>
            <b-row>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Cari"></b-form-input>

                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table
              :items="userSettingList"
              :fields="fields"
              :busy="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              responsive
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo" /><br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(image_path)="row">
                <div class="media d-flex justify-content-center">
                  <a href="javascript:void(0)" class="avatar rounded-circle">
                    <img alt="" height="50px" :src="row.item.image_path" />
                  </a>
                </div>
              </template>
              <template #cell(full_name)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.full_name }}</label>
                </div>
              </template>
              <template #cell(email)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.email }}</label>
                </div>
              </template>
              <template #cell(gender)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.gender }}</label>
                </div>
              </template>
              <!-- <template #cell(user_status)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.user_status }}</label>
                </div>
              </template>
              <template #cell(is_active)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.is_active == "0" ? "Ya" : "Tidak" }}</label>
                </div>
              </template> -->
              <template #cell(current_class)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.type == "murid" ? row.item.current_class : "" }}</label>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="my-2">
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Detail" class="icon-clicked p-1" @click="showDetail(row.item)"><i class="fa fa-eye" aria-hidden="true"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Download Formulir" class="icon-clicked p-1" @click="cetakFormulir(row.item)"><i class="fa fa-download" aria-hidden="true"></i></a>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-lg-end justify-content-center py-2">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </card>
    <b-modal ref="user-import-form-modal" class="user-import-form-modal" size="md" title="Import Data" @show="resetImportForm" @hidden="resetImportForm" hide-footer no-close-on-backdrop>
      <b-form data-vv-scope="user-import-form">
        <b-form-group label="Data" label-for="data" label-cols-sm="3" label-align-sm="left">
          <b-form-file
            ref="file_path"
            name="file_path"
            data-vv-as="File data"
            v-model="import_form.file_data"
            :state="Boolean(import_form.file_data)"
            type="file"
            placeholder="Pilih file disini. . ."
            drop-placeholder="Drop file here..."
            v-validate="'required'"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
          </b-form-file>
          <span :class="{ 'error-validation': errors.first('user-import-form.file_path') }">{{ errors.first("user-import-form.file_path") }}</span>
        </b-form-group>
      </b-form>
      <hr class="m-0" />
      <div class="form-footer d-flex justify-content-end mt-3">
        <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
        <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%" @click="hideImportFormModal">BATAL</b-button>
        <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%" @click.prevent="saveImportSoal">UPLOAD</b-button>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.foto-field {
  height: 50px;
}
</style>
<script>
import { mapGetters } from "vuex";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
// import axios from "axios";

export default {
  props: {
    //
  },
  components: {
    SquareLoader,
  },
  data() {
    return {
      import_form: {
        file_data: null,
      },
      statusList: [
        {
          id: "1",
          name: "Tidak",
        },
        {
          id: "0",
          name: "Ya",
        },
      ],
      filter_form: {
        type: "murid",
        status: "1",
        class_id: 0,
        ta_id: 0,
      },
      showLoader: false,
      isBusy: false,
      fields: [
        { key: "image_path", label: "Foto", sortable: false, class: "foto-field" },
        { key: "full_name", label: "Nama Lengkap", sortable: true, class: "text-left" },
        { key: "email", label: "Email", sortable: true, sortDirection: "desc", class: "text-left" },
        { key: "gender", label: "Jenis Kelamin", sortable: true, class: "text-center" },
        // { key: "user_status", label: "Status", sortable: true, class: "text-center" },
        // { key: "is_active", label: "Keluar/Lulus", sortable: true, class: "text-center" },
        { key: "current_class", label: "Kelas Sekarang", sortable: true, class: "text-center" },
        { key: "actions", label: "Aksi", class: "action-field" },
      ],
      genderList: [
        {
          id: null,
          name: "Pilih jenis kelamin",
        },
        {
          id: "L",
          name: "Laki-laki",
        },
        {
          id: "P",
          name: "Perempuan",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 400, 800, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
    computed: {
      ...mapGetters({
        user: "getUser",
        userSettingList: "FormulirPendaftaran/getFormulirPendaftaranList",
        totalACtive: "FormulirPendaftaran/getFormulirPendaftaranList",
        userTypeList: "FormulirPendaftaran/getFormulirTypeList",
        taList: "FormulirPendaftaran/getFormulirTaList",
        classesList: "FormulirPendaftaran/getFormulirClassesList",
        token: "getToken",
      }),
    },
  watch: {
    userSettingList(val) {
      this.totalRows = val.length;
      this.totalActive = val.length;
    },
  },
  methods: {
    showDetail(user) {
      this.$router.push(`/formulir-pendaftaran/${user.id}`);
    },
    cetakFormulir(user) {
      let route = 'https://daring.api.pkbm-binapandumandiri.or.id/api/v1/formulir-pendaftaran/cetak-formulir/' + user.id + '?token=' + this.token;
      // let route = 'http://localhost:8000/api/v1/formulir-pendaftaran/cetak-formulir/' + user.id + '?token=' + this.token;
      window.open(route);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },
    async getFormulirPendaftaranList() {
      this.isBusy = true;
      await this.$store
        .dispatch("FormulirPendaftaran/getFormulirPendaftaranList", this.filter_form)
        .then((res) => {
          this.totalActive = res.data.message;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getFormulirTypeList() {
      this.isBusy = true;
      await this.$store
        .dispatch("FormulirPendaftaran/getFormulirTypeList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getFormulirTaList() {
      this.isBusy = true;
      await this.$store
        .dispatch("FormulirPendaftaran/getFormulirTaList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getFormulirClassesList() {
      this.isBusy = true;
      await this.$store
        .dispatch("FormulirPendaftaran/getFormulirClassesList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    showImportFormModal() {
      this.$refs["user-import-form-modal"].show();
    },
    hideImportFormModal() {
      this.$refs["user-import-form-modal"].hide();
      this.resetImportForm();
      this.getFormulirPendaftaranList();
    },
    resetImportForm() {
      this.import_form.file_data = null;
      this.$validator.reset();
    },
    async saveImportSoal() {
      let scope = "user-import-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let formData = new FormData();
          formData.append("file", this.import_form.file_data);
          this.$store
            .dispatch("FormulirPendaftaran/importFormData", formData)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
  },
  mounted() {
    this.totalRows = this.userSettingList.length;
  },
  async created() {
    await this.getFormulirTaList();
    if (this.taList && this.taList.length > 0) {
      let activeTa = this.taList.find((ta) => ta.is_current == "1");
      if (activeTa) {
        this.filter_form.ta_id = activeTa.id;
      } else {
        this.filter_form.ta_id = this.taList[0].id;
      }
    }
    await this.getFormulirPendaftaranList();
    await this.getFormulirTypeList();
    await this.getFormulirTaList();
    await this.getFormulirClassesList();
  },
};
</script>
<style lang="css" scoped>
.line-with-icon svg {
  /* color: #adb7be; */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1rem;
}
.line-with-icon {
  position: relative;
  padding: 0 0 0 1.75em;
  margin: 0 0 1em;
}
.user-article a {
  color: black;
}
.class-list > .line-with-icon > a {
  color: #ca062a;
}
.user-article a:hover {
  color: #ca062a;
}

.btn-open-answer {
  color: #6c757d;
}
.btn-open-answer:hover {
  color: #ca062a;
}
</style>
